<template>
    <div class="container storefront-container mx-auto">
    <div class="storefront-heading-container flex h-72 lg:mb-0 mb-4">
        <div class="w-full h-3/5 invisible sm:visible">
            <img
                class="w-full h-full"
                :src="'/img/sample-banner.png'"
            />
        </div>

        <div
            class="absolute top-[12%] left-10 sm:-translate-x-1/2 sm:top-[15%] sm:left-[12%] h-32 w-32 md:w-40 md:h-40 md:transform-none"
        >
            <div class="rounded-full bg-white">
                <svg-vue
                    icon="circle-user"
                    title="default user avatar"
                    class="h-32 w-32 md:w-40 md:h-40"
                />
            </div>
        </div>
        </div>

        <div class="flex">
            <div class="justify-center items-center">
                <h2 class="text-2xl mr-2">
                    {{ organization.dba? organization.dba : organization.name }}
                </h2>
                <p>
                    Coming Soon!
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrgPending",
    props: [
        "organization",
        ],
}
</script>

<style scoped>

</style>
